const str = `{HEADER}저작권 정책
{HEADER_SUB}이 약관은 ㈜비디오몬스터(이하 ‘회사’라 한다.)가 운영하는 카페24 전용 비디오몬스터 웹사이트에서 제공하는 영상 템플릿 및 각종 콘텐츠에 대한 저작권을 규정하기 위한 것으로 비디오몬스터를 사용하는 사용자는 아래의 항목에 동의한 것으로 간주합니다.

{BODY_TITLE}제1조 (용어의 정의)
1) ‘템플릿’이라 함은 회사가 비디오몬스터를 통해 제공하는, 정보 전달 목적의 미리 제작된 영상결과물로서, 복수의 디자인 요소로 구성이 되어져 있으며, 편집기를 통해 편집이 가능합니다.
2) ‘디자인 요소’라 함은 템플릿을 이루는 단수 또는 복수의 “영상, 사진, 아이콘, 이미지, 도형, 텍스트 등” 과 같은 요소를 말합니다.
3) ‘편집기’라 함은 템플릿을 편집하는 소프트웨어를 뜻합니다.
4) ‘사용자 템플릿’이라 함은 사용자가 제공된 템플릿을 편집기로 작업한 결과물을 의미합니다.

{BODY_TITLE}제2조 (비디오몬스터의 사용)
1) 회사가 비디오몬스터를 통해 제공하는 모든 콘텐츠(템플릿을 포함한 모든 디자인 요소를 통칭함)는 비디오몬스터에서 저작권을 소유하고 있거나, 제휴사로부터 비디오몬스터 편집기에서 사용이 가능토록 허가를 받아 제공되고 있습니다.
2) 사용자는 비디오몬스터에서 제공되는 디자인 요소를 개별 단독으로 다운로드 혹은 캡쳐 등을 통하여 복제하거나, 이를 수정하여 사용할 수 없습니다. 다만 비디오몬스터에서 제공되는 템플릿은 비디오몬스터 편집기를 통해 수정 가능하며, 이의 작업결과물을 사용할 순 있습니다.
3) 사용자는 콘텐츠 및 편집기를 회사의 허락없이 다른 서버에 미러링할 수 없습니다.
4) 사용자는 비디오몬스터에서 제공하는 템플릿을 복제 및 수정하여, 이를 편집이 가능한 템플릿으로 재판매할 수 없습니다.
5) 무료사용자의 경우 콘텐츠에 포함된 워터마크 혹은 회사의 로고 등 회사에 의하여 삽입된 표식을 제거할 수 없습니다.
6) 유료사용자의 경우 기업이나 단체, 공공기관 등 재판매 및 대행 클라이언트(광고대행) 목적으로 사용시에는 이에 맞는 요금제(현재 ‘재판매 및 에이전시 요금제’가 이에 해당합니다)를 사용하여야 하며 월 정기결제 및 기간제 요금제 등 다른 요금제는 재판매 및 대행 클라이언트로 사용하는 것이 엄격히 금지됩니다.
이 경우 회사는 통지없이 서비스를 중지할 수 있으며, 이 때 잔여기간이 있더라도 환불 받을 수 없습니다.
7) 유료사용자는 타인에게 이용권을 양도, 판매, 대여할 수 없습니다.
8) 사용자는 자신의 ID와 비밀번호를 타인과 공유하여 사용할 수 없습니다.

{BODY_TITLE}제3조 (사용자가 만든 템플릿의 사용 제한)
1) 비디오몬스터 편집기에서 제공되는 템플릿과 디자인 요소로 만든 사용자 템플릿은 상업적 혹은 비상업적 용도로 사용하실 수 있습니다. 인터넷에 자유롭게 게시 및 공유, 배포하여 사용할 수 있습니다.
단, 사용자가 비디오몬스터 편집기에 직접 업로드한 디자인 요소에 대해서는 사용자가 직접 사용 허가 범위를 확인해야 합니다. 사용자가 업로드한 디자인 요소에 대한 저작권, 초상권, 퍼블리시티권 관련 책임은 사용자에게 있습니다.
2) 사용자는 비디오몬스터에서 제공하는 템플릿 및 디자인 요소를 이용하고 이에 창작성을 가미하여 만든 ‘사용자 템플릿’의 재판매 및 대행 클라이언트는 에이전시 요금제 이용시에만 가능합니다.
단, 이를 편집이 가능한 템플릿 형태로 배포 또는 판매하거나, 또한 아무런 창작성이 가미되지 않은 복제물을 판매할 수 없습니다.
3) 사용자는 편집기를 이용하여 만든 사용자 템플릿을 다른 편집도구를 사용하여 재편집할 수 없습니다. 단, 아래사항은 예외로 합니다.
다운받은 작업결과물의 파일 형식 변환은 가능합니다.
다운받은 작업결과물을 다른 영상에 원본 그대로 삽입하거나 결합하여 사용할 수 있습니다.
다운받은 작업결과물에 자막, 더빙, 요소, 효과삽입과 길이를 자르기 및 붙이기 할 수 있습니다.
4) 사용자는 비디오몬스터에서 제공하는 '디자인 요소'가 포함된 사용자 템플릿을 가지고 지식재산권(저작권, 상표권, 디자인권, 특허권)의 권리를 일방적으로 등록하거나 주장할 수 없습니다. 사용자가 비디오몬스터에서 제공하는 ‘디자인 요소’가 포함된 2차 저작물을 작성하고, 이를 사용허락하거나 양도함으로서 제3자로부터 수익을 얻고자 할 경우, 사전에 비디오몬스터와 이와 관련하여 협의를 요청하여야 합니다.

{BODY_TITLE}제4조 (회사의 면책)
1) 회사는 비디오몬스터 내의 모든 콘텐츠의 내용 및 의미에 대하여 정확성이나, 신뢰성을 보증하지 않으며 사용자가 이를 이용함으로써 발생하는 문제는 사용자에게 있습니다.
2) ‘사용자 템플릿’에 담긴 내용 및 의미로 인해 발생하는 모든 책임은 회사에 있지 않고, 이를 제작한 사용자에게 있습니다.
3) 사용자가 업로드한 디자인 요소의 일부 혹은 전부가 타인의 권리를 침해한 경우의 책임은 회사에 있지 않고, 이를 업로드한 사용자에게 있습니다.
4) 회사는 사용자 상호간 및 사용자와 제3자 상호 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이에 따른 손해를 배상할 책임도 없습니다.
5) 사용자는 회사와 사전협의 없이 "저작권 정책"을 벗어나는 용도로 사용할 경우, 제작한 사용자 템플릿에 대하여 저작권 보호를 받을 수 없으며, 적발 시 형사처벌이나 손해 배상의 의무를 지게됩니다.

{BODY_TITLE}제5조 (제약사항)
1) 비디오몬스터에서 제공된 사진(이미지) 등을 외설적인 목적으로 활용하거나 타인의 명예를 훼손하거나 모욕하는 등 법을 위반하는 목적으로 사용할 수 없습니다.
2) 비디오몬스터를 통해 사회미풍양속을 저해하는 용도(성인오락실, 전화방, 음란물, 채팅 사이트, 성인 커뮤니티, 성인제품, 유흥업소 및 숙박업소 등의 성인관련 사이트 및 인쇄물)나, 고리대금업, 운세상담, 사주풀이, 미팅알선, 결혼정보, 종교적, 정치적 목적 등에 사용하는 것을 금합니다.
3) 비디오몬스터에서 제공하는 동영상(Video), 이미지(Images), 음악(Music), 폰트(Font) 외 My서비스를 자신의 동영상, 이미지, 음악, 폰트를 업로드하여 사용하는 경우, 배포가 허락된 타 저작권사의 제약사항은 반드시 지켜야 합니다.
4) 비디오몬스터내의 픽셀스(Pexels), 픽사베이(Pixbay), 언스플래쉬(Unsplash), 게티이미지(Gettyimages)에서 제공되는 모든 이미지 및 동영상은 아래의 제약사항을 지켜야 합니다.
① 기업 CI, BI 로고 및 성형, 포르노, 성인용품, 마약, 도박, 사행성게임 관련, 비방을 목적으로 하는 용도에 이용할 수 없으며 피사체에 대한 명예훼손 및 인격권침해 등 일반 정서에 반하는 용도로는 이용할 수 없습니다.
② 원본 그대로를 복사해서 판매할 수 없습니다.
③ 식별 가능한 인물이나 개인재산, 상표, 로고등을 사용할 경우, 법률이나 명예훼손 등의 사회상규에 위배되거나, 전속모델로 오인되거나, 다른 제품이나 서비스와 연관된 것처럼 보이도록 이용할 수 없습니다.
* 자세한 규정은 각 홈페이지에서 확인할 수 있으며, 저작권 규정에 위배되어 원저작권자에게 피해가 발생시 책임은 저작권 규정을 위반한 사용자에게 있습니다.

{BODY_TITLE}제6조 (문의)
저작권에 대한 문의는 아래의 이메일로 문의할 수 있습니다.
Email: support@videomonster.com
`

export default str